import { combineReducers } from "redux";
import checkups from "./checkupReducer";
import users from "./usersReducer";
import parks from "./parksReducer";
import stations from "./stationsReducer";
import auth from "./auth";
import parts from "./partsReducer";

export default combineReducers({
  checkups,
  users,
  parks,
  stations,
  auth,
  parts,
});
